import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import "./ViewPage.css";
import axios from "axios";

const ViewTask = () => {
  const { task_id } = useParams();
  const navigate = useNavigate();

  const [task, setTask] = useState(null);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    axios.post(`${API_BASE_URL}task_detail.php`,{task_id:task_id})
      .then((response) => {
        if (response.data.head.code === 200 ) {
          setTask(response.data.body);
          // setFilteredOrders(response.data.body);

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setTask([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setTask([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  }, []);

  if (!task) {
    return (
      <Container fluid className="outer-container my-4">
        <h2 className="text-center mb-3">View Task</h2>
        <Row>
          <Col>
            <div className="not-found-box">Loading...</div>
          </Col>
        </Row>
      </Container>
    );
  }

  const fields = [
    { label: "Theme", value: task.task_theme },
    { label: "Title", value: task.task_name },
    { label: "Description", value: task.description },
    { label: "Priority", value: task.priority },
    { label: "Due Date", value: task.due_date },
    { label: "Status", value: task.status },
    { label: "Assigned To", value: task.assigned_to_name },
    { label: "Assigned By", value: task.assigned_by_name },
    { label: "Created At", value: task.created_at },
    // { label: "Updated At", value: task.updated_at },
  ];

  return (
    <Container fluid className="outer-container my-4">
      <h2 className="text-center mb-3">View Task</h2>

      <div className="customer-header d-flex justify-content-end align-items-center mb-3">
        <Button className="btn-top" onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>

      <div className="customer-view-wrapper">
        <div className="customer-view-card">
          {/* keep left column for consistent layout across views; empty for task */}
          <div className="customer-photo-wrap" aria-hidden />

          <div className="customer-details-table-wrapper">
            <table
              className="customer-view-table"
              role="table"
              aria-label={`Task details for ${task.task_name}`}
            >
              {/* <thead>
                <tr>
                  <th style={{ width: "36%" }}>Field</th>
                  <th style={{ width: "64%" }}>Value</th>
                </tr>
              </thead> */}
              <tbody>
                {fields.map((f, i) => (
                  <tr key={i}>
                    <td className="field-cell">{f.label}</td>
                    <td className="value-cell">{f.value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ViewTask;
